import { render, staticRenderFns } from "./Kicked.vue?vue&type=template&id=025fa59f"
import script from "./Kicked.vue?vue&type=script&lang=js"
export * from "./Kicked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025fa59f')) {
      api.createRecord('025fa59f', component.options)
    } else {
      api.reload('025fa59f', component.options)
    }
    module.hot.accept("./Kicked.vue?vue&type=template&id=025fa59f", function () {
      api.rerender('025fa59f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Kicked.vue"
export default component.exports